import { render, staticRenderFns } from "./FormVAAttachments.vue?vue&type=template&id=79b9e8ec&"
import script from "./FormVAAttachments.vue?vue&type=script&lang=js&"
export * from "./FormVAAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports